import React, { useEffect } from "react";
import { Button, Col, Form, Input, Row, Typography } from "antd";
import { useHistory, useLocation } from "react-router-dom";

import { PATHS } from "@config/constants";
import { useLogin } from "dataLayer/user";
import { useTranslation } from "react-i18next";
import BitelModal from "@components/Modal";

const { Text, Title } = Typography;

const LoginPage = () => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const { mutate, data, error, isLoading } = useLogin();
  const history = useHistory();

  useEffect(() => {
    const queryParams = new URLSearchParams(search);
    const msisdn = queryParams.get("msisdn");
    const customerId = queryParams.get("customerId");
    const tokenEncoded = queryParams.get("tokenEncoded");
    const os = queryParams.get("os");
    const versionApp = queryParams.get("versionApp");
    const versionOs = queryParams.get("versionOs");

    if (msisdn && customerId && tokenEncoded) {
      mutate({ isdn: msisdn, customerId, tokenEncoded, os, versionApp, versionOs });
    }
  }, [mutate, search]);

  const onFinish = (values) => {
    mutate(values, {
      onSuccess: () => {
        history.push(PATHS.BID_PAGE);
      },
    });
  };

  useEffect(() => {
    document.title = t("title.login");
  }, [t]);
  
  return (
    <div className="login-page-wrapper">
      <div className="login-page-form">
        <Title level={2} className="login-page-form-title">{t("login.title")}</Title>
        <Text className="login-page-form-detail">{t("login.title_detail")}</Text>
        <Row gutter={[10, 10]} justify="center">
          <Col xs={24} md={20} lg={20} xl={14}>
            <Form
              name="basic"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              autoComplete="off"
              className="custom-form"
            >
              <Form.Item
                name="isdn"
                rules={[{ required: true, message: t("error.missing.phonenumber") }]}
              >
                <Input className="custom-form-input" placeholder={t("login.form.isdn")} />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: t("error.missing.password") }]}
              >
                <Input.Password placeholder={t("login.form.password")} />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" className="custom-form-button" loading={isLoading}>
                  {t("login.form.btnLogin")}
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
      <div className="login-page-action">
        <Row>
          <Col>
            <div className="text-left">
              <Text className="login-page-text">{t("login.do_not_has_account")}</Text>
              <a href={PATHS.REGISTER_PAGE} className="login-page-sign-up" target="_self">
                {t("login.call_click_sign_up")}
              </a>
            </div>
          </Col>
          {/* <Col xs={12} xl={8}>
            <div className="text-right">
              <Link to={PATHS.FORGOT_PASSWORD_PAGE} className="login-page-forgot">
                {t("login.forgot_password")}
              </Link>
            </div>
          </Col> */}
        </Row>
      </div>
      <BitelModal error={error} data={data} />
    </div >
  );
};

export default LoginPage;
